export default __webpack_public_path__ + "static/media/6.28420ec9.jpeg";